/**
 * Kuratierte Lesesilben für den Calepia-Grundwortschatz Hessen.
 * Erzeugt mit deutschen Trennmustern und gezielt geprüften Ausnahmen.
 */
export const GRUNDWORTSCHATZ_HESSEN_SYLLABLES: Readonly<Record<string, readonly string[]>> = {
  "acht": ["acht"],
  "alt": ["alt"],
  "angst": ["Angst"],
  "ast": ["Ast"],
  "baum": ["Baum"],
  "bein": ["Bein"],
  "blau": ["blau"],
  "braun": ["braun"],
  "breit": ["breit"],
  "brief": ["Brief"],
  "brot": ["Brot"],
  "buch": ["Buch"],
  "bunt": ["bunt"],
  "dach": ["Dach"],
  "drei": ["drei"],
  "ei": ["Ei"],
  "eins": ["eins"],
  "eis": ["Eis"],
  "elf": ["elf"],
  "fach": ["Fach"],
  "fein": ["fein"],
  "feucht": ["feucht"],
  "fisch": ["Fisch"],
  "frau": ["Frau"],
  "frisch": ["frisch"],
  "fünf": ["fünf"],
  "gleich": ["gleich"],
  "gras": ["Gras"],
  "grün": ["grün"],
  "gut": ["gut"],
  "hals": ["Hals"],
  "haus": ["Haus"],
  "heft": ["Heft"],
  "hut": ["Hut"],
  "jung": ["jung"],
  "kalt": ["kalt"],
  "klein": ["klein"],
  "knie": ["Knie"],
  "kopf": ["Kopf"],
  "kraut": ["Kraut"],
  "kreis": ["Kreis"],
  "lang": ["lang"],
  "laut": ["laut"],
  "leicht": ["leicht"],
  "licht": ["Licht"],
  "loch": ["Loch"],
  "los": ["los"],
  "luft": ["Luft"],
  "maus": ["Maus"],
  "mensch": ["Mensch"],
  "milch": ["Milch"],
  "nacht": ["Nacht"],
  "neu": ["neu"],
  "neun": ["neun"],
  "pilz": ["Pilz"],
  "reich": ["reich"],
  "ring": ["Ring"],
  "rot": ["rot"],
  "saft": ["Saft"],
  "salz": ["Salz"],
  "schal": ["Schal"],
  "schief": ["schief"],
  "schön": ["schön"],
  "schrift": ["Schrift"],
  "seil": ["Seil"],
  "tisch": ["Tisch"],
  "tun": ["tun"],
  "weit": ["weit"],
  "welt": ["Welt"],
  "zaun": ["Zaun"],
  "zeit": ["Zeit"],
  "zwei": ["zwei"],
  "zwölf": ["zwölf"],
  "ameise": ["A","mei","se"],
  "auge": ["Au","ge"],
  "biene": ["Bie","ne"],
  "blume": ["Blu","me"],
  "blüte": ["Blü","te"],
  "böse": ["bö","se"],
  "ende": ["En","de"],
  "ente": ["En","te"],
  "eule": ["Eu","le"],
  "freude": ["Freu","de"],
  "gemüse": ["Ge","mü","se"],
  "hase": ["Ha","se"],
  "heute": ["heu","te"],
  "hose": ["Ho","se"],
  "junge": ["Jun","ge"],
  "küche": ["Kü","che"],
  "leise": ["lei","se"],
  "leute": ["Leu","te"],
  "name": ["Na","me"],
  "nase": ["Na","se"],
  "ochse": ["Och","se"],
  "pflaume": ["Pflau","me"],
  "raupe": ["Rau","pe"],
  "riese": ["Rie","se"],
  "sache": ["Sa","che"],
  "schere": ["Sche","re"],
  "schlange": ["Schlan","ge"],
  "seife": ["Sei","fe"],
  "seite": ["Sei","te"],
  "tante": ["Tan","te"],
  "tasche": ["Ta","sche"],
  "wiese": ["Wie","se"],
  "woche": ["Wo","che"],
  "bauen": ["bau","en"],
  "biegen": ["bie","gen"],
  "bleiben": ["blei","ben"],
  "brauchen": ["brau","chen"],
  "bringen": ["brin","gen"],
  "dachten": ["dach","ten"],
  "fangen": ["fan","gen"],
  "finden": ["fin","den"],
  "fliegen": ["flie","gen"],
  "fragen": ["fra","gen"],
  "freuen": ["freu","en"],
  "frieden": ["Frie","den"],
  "frieren": ["frie","ren"],
  "geben": ["ge","ben"],
  "halten": ["hal","ten"],
  "helfen": ["hel","fen"],
  "holen": ["ho","len"],
  "hören": ["hö","ren"],
  "impfen": ["imp","fen"],
  "kaufen": ["kau","fen"],
  "kleben": ["kle","ben"],
  "kochen": ["ko","chen"],
  "kriechen": ["krie","chen"],
  "kriegen": ["krie","gen"],
  "kuchen": ["Ku","chen"],
  "lachen": ["la","chen"],
  "laufen": ["lau","fen"],
  "leben": ["le","ben"],
  "legen": ["le","gen"],
  "lesen": ["le","sen"],
  "leuchten": ["leuch","ten"],
  "liegen": ["lie","gen"],
  "machen": ["ma","chen"],
  "malen": ["ma","len"],
  "oben": ["oben"],
  "pflanzen": ["pflan","zen"],
  "pflegen": ["pfle","gen"],
  "rechnen": ["rech","nen"],
  "reden": ["re","den"],
  "regen": ["Re","gen"],
  "reisen": ["rei","sen"],
  "riechen": ["rie","chen"],
  "rufen": ["ru","fen"],
  "sagen": ["sa","gen"],
  "schauen": ["schau","en"],
  "scheinen": ["schei","nen"],
  "schieben": ["schie","ben"],
  "schimpfen": ["schimp","fen"],
  "schlafen": ["schla","fen"],
  "schlagen": ["schla","gen"],
  "schneiden": ["schnei","den"],
  "schreiben": ["schrei","ben"],
  "schreien": ["schrei","en"],
  "schweigen": ["schwei","gen"],
  "sieben": ["sie","ben"],
  "singen": ["sin","gen"],
  "suchen": ["su","chen"],
  "tragen": ["tra","gen"],
  "üben": ["üben"],
  "unten": ["un","ten"],
  "waschen": ["wa","schen"],
  "wünschen": ["wün","schen"],
  "zeigen": ["zei","gen"],
  "zwischen": ["zwi","schen"],
  "ampel": ["Am","pel"],
  "apfel": ["Ap","fel"],
  "bügel": ["Bü","gel"],
  "flügel": ["Flü","gel"],
  "gabel": ["Ga","bel"],
  "insel": ["In","sel"],
  "nebel": ["Ne","bel"],
  "nabel": ["Na","bel"],
  "nudel": ["Nu","del"],
  "pinsel": ["Pin","sel"],
  "schnabel": ["Schna","bel"],
  "tafel": ["Ta","fel"],
  "teufel": ["Teu","fel"],
  "windel": ["Win","del"],
  "zwiebel": ["Zwie","bel"],
  "bruder": ["Bru","der"],
  "erster": ["ers","ter"],
  "euer": ["eu","er"],
  "fenster": ["Fens","ter"],
  "feuer": ["Feu","er"],
  "finger": ["Fin","ger"],
  "hunger": ["Hun","ger"],
  "keiner": ["kei","ner"],
  "kleber": ["Kle","ber"],
  "leider": ["lei","der"],
  "leiter": ["Lei","ter"],
  "meter": ["Me","ter"],
  "pflaster": ["Pflas","ter"],
  "schwester": ["Schwes","ter"],
  "selber": ["sel","ber"],
  "tochter": ["Toch","ter"],
  "anders": ["an","ders"],
  "eltern": ["El","tern"],
  "flüstern": ["flüs","tern"],
  "gestern": ["ges","tern"],
  "hundert": ["hun","dert"],
  "ostern": ["Os","tern"],
  "bier": ["Bier"],
  "flur": ["Flur"],
  "papier": ["Pa","pier"],
  "schnur": ["Schnur"],
  "schwer": ["schwer"],
  "tier": ["Tier"],
  "tor": ["Tor"],
  "tür": ["Tür"],
  "antworten": ["ant","wor","ten"],
  "birne": ["Bir","ne"],
  "dort": ["dort"],
  "durst": ["Durst"],
  "erde": ["Er","de"],
  "erst": ["erst"],
  "gerne": ["ger","ne"],
  "gurke": ["Gur","ke"],
  "herz": ["Herz"],
  "kirche": ["Kir","che"],
  "kirsche": ["Kir","sche"],
  "körper": ["Kör","per"],
  "kurz": ["kurz"],
  "lernen": ["ler","nen"],
  "merken": ["mer","ken"],
  "morgen": ["mor","gen"],
  "turnen": ["tur","nen"],
  "wort": ["Wort"],
  "würfel": ["Wür","fel"],
  "wurm": ["Wurm"],
  "wurst": ["Wurst"],
  "wurzel": ["Wur","zel"],
  "arbeiten": ["ar","bei","ten"],
  "arm": ["Arm"],
  "farbe": ["Far","be"],
  "hart": ["hart"],
  "klar": ["klar"],
  "marke": ["Mar","ke"],
  "nachbar": ["Nach","bar"],
  "scharf": ["scharf"],
  "sogar": ["so","gar"],
  "schwarz": ["schwarz"],
  "warm": ["warm"],
  "warten": ["war","ten"],
  "als": ["als"],
  "auch": ["auch"],
  "auf": ["auf"],
  "aus": ["aus"],
  "bei": ["bei"],
  "bist": ["bist"],
  "da": ["da"],
  "dein": ["dein"],
  "dem": ["dem"],
  "den": ["den"],
  "dich": ["dich"],
  "die": ["die"],
  "dies": ["dies"],
  "doch": ["doch"],
  "du": ["du"],
  "ein": ["ein"],
  "euch": ["euch"],
  "ganz": ["ganz"],
  "ich": ["ich"],
  "ist": ["ist"],
  "ja": ["ja"],
  "kein": ["kein"],
  "mein": ["mein"],
  "mich": ["mich"],
  "nach": ["nach"],
  "nein": ["nein"],
  "nicht": ["nicht"],
  "nichts": ["nichts"],
  "nie": ["nie"],
  "noch": ["noch"],
  "nun": ["nun"],
  "oft": ["oft"],
  "schon": ["schon"],
  "sein": ["sein"],
  "seit": ["seit"],
  "sich": ["sich"],
  "sie": ["sie"],
  "so": ["so"],
  "uns": ["uns"],
  "weil": ["weil"],
  "wem": ["wem"],
  "wen": ["wen"],
  "wie": ["wie"],
  "wo": ["wo"],
  "zu": ["zu"],
  "der": ["der"],
  "dir": ["dir"],
  "durch": ["durch"],
  "dürfen": ["dür","fen"],
  "er": ["er"],
  "für": ["für"],
  "her": ["her"],
  "hier": ["hier"],
  "mir": ["mir"],
  "nur": ["nur"],
  "war": ["war"],
  "wer": ["wer"],
  "werden": ["wer","den"],
  "zur": ["zur"],
  "am": ["am"],
  "an": ["an"],
  "bin": ["bin"],
  "bis": ["bis"],
  "das": ["das"],
  "des": ["des"],
  "es": ["es"],
  "hat": ["hat"],
  "hin": ["hin"],
  "im": ["im"],
  "in": ["in"],
  "man": ["man"],
  "mit": ["mit"],
  "um": ["um"],
  "warum": ["war","um"],
  "was": ["was"],
  "zum": ["zum"],
  "alle": ["al","le"],
  "dann": ["dann"],
  "denn": ["denn"],
  "hatte": ["hat","te"],
  "immer": ["im","mer"],
  "können": ["kön","nen"],
  "müssen": ["müs","sen"],
  "sollen": ["sol","len"],
  "wann": ["wann"],
  "wenn": ["wenn"],
  "wollen": ["wol","len"],
  "ab": ["ab"],
  "bald": ["bald"],
  "seid": ["seid"],
  "sind": ["sind"],
  "und": ["und"],
  "ihm": ["ihm"],
  "ihn": ["ihn"],
  "ihr": ["ihr"],
  "mehr": ["mehr"],
  "sehr": ["sehr"],
  "ohne": ["oh","ne"],
  "viel": ["viel"],
  "vom": ["vom"],
  "von": ["von"],
  "vor": ["vor"],
  "aber": ["aber"],
  "hinter": ["hin","ter"],
  "oder": ["oder"],
  "über": ["über"],
  "unter": ["un","ter"],
  "weiter": ["wei","ter"],
  "wieder": ["wie","der"],
  "also": ["al","so"],
  "eure": ["eu","re"],
  "etwas": ["et","was"],
  "gegen": ["ge","gen"],
  "habe": ["ha","be"],
  "haben": ["ha","ben"],
  "jede": ["je","de"],
  "mögen": ["mö","gen"],
  "waren": ["wa","ren"],
  "welche": ["wel","che"],
  "sparen": ["spa","ren"],
  "spiegel": ["Spie","gel"],
  "spielen": ["spie","len"],
  "sport": ["Sport"],
  "sprechen": ["spre","chen"],
  "springen": ["sprin","gen"],
  "stein": ["Stein"],
  "stern": ["Stern"],
  "stift": ["Stift"],
  "stolz": ["stolz"],
  "strauch": ["Strauch"],
  "streichen": ["strei","chen"],
  "streiten": ["strei","ten"],
  "stunde": ["Stun","de"],
  "sturm": ["Sturm"],
  "spaß": ["Spaß"],
  "spät": ["spät"],
  "spaziergang": ["Spa","zier","gang"],
  "spinne": ["Spin","ne"],
  "spitz": ["spitz"],
  "stadt": ["Stadt"],
  "stamm": ["Stamm"],
  "stark": ["stark"],
  "stehen": ["ste","hen"],
  "stellen": ["stel","len"],
  "still": ["still"],
  "stimme": ["Stim","me"],
  "stoff": ["Stoff"],
  "strand": ["Strand"],
  "straße": ["Stra","ße"],
  "stück": ["Stück"],
  "stuhl": ["Stuhl"],
  "bank": ["Bank"],
  "danken": ["dan","ken"],
  "denken": ["den","ken"],
  "dunkel": ["dun","kel"],
  "krank": ["krank"],
  "onkel": ["On","kel"],
  "punkt": ["Punkt"],
  "schenken": ["schen","ken"],
  "schrank": ["Schrank"],
  "trinken": ["trin","ken"],
  "bequem": ["be","quem"],
  "quadrat": ["Qua","drat"],
  "quaken": ["qua","ken"],
  "qualle": ["Qual","le"],
  "quark": ["Quark"],
  "quatsch": ["Quatsch"],
  "quelle": ["Quel","le"],
  "quer": ["quer"],
  "quietschen": ["quiet","schen"],
  "affe": ["Af","fe"],
  "backen": ["ba","cken"],
  "besser": ["bes","ser"],
  "bett": ["Bett"],
  "bitten": ["bit","ten"],
  "blicken": ["bli","cken"],
  "blitz": ["Blitz"],
  "block": ["Block"],
  "brennen": ["bren","nen"],
  "brille": ["Bril","le"],
  "brücke": ["Brü","cke"],
  "butter": ["But","ter"],
  "decke": ["De","cke"],
  "dick": ["dick"],
  "doppelt": ["dop","pelt"],
  "dreckig": ["dre","ckig"],
  "drucken": ["dru","cken"],
  "drücken": ["drü","cken"],
  "dumm": ["dumm"],
  "dünn": ["dünn"],
  "fett": ["fett"],
  "fluss": ["Fluss"],
  "flüssig": ["flüs","sig"],
  "fressen": ["fres","sen"],
  "füller": ["Fül","ler"],
  "glatt": ["glatt"],
  "glück": ["Glück"],
  "gott": ["Gott"],
  "gucken": ["gu","cken"],
  "hell": ["hell"],
  "herr": ["Herr"],
  "hessen": ["Hes","sen"],
  "himmel": ["Him","mel"],
  "hitze": ["Hit","ze"],
  "hoffen": ["hof","fen"],
  "jacke": ["Ja","cke"],
  "katze": ["Kat","ze"],
  "kennen": ["ken","nen"],
  "klasse": ["Klas","se"],
  "klettern": ["klet","tern"],
  "kommen": ["kom","men"],
  "kratzen": ["krat","zen"],
  "lassen": ["las","sen"],
  "lecker": ["le","cker"],
  "löffel": ["Löf","fel"],
  "messen": ["mes","sen"],
  "messer": ["Mes","ser"],
  "mitte": ["Mit","te"],
  "mutter": ["Mut","ter"],
  "müll": ["Müll"],
  "mütze": ["Müt","ze"],
  "null": ["Null"],
  "nummer": ["Num","mer"],
  "nuss": ["Nuss"],
  "offen": ["of","fen"],
  "packen": ["pa","cken"],
  "passen": ["pas","sen"],
  "pflücken": ["pflü","cken"],
  "platz": ["Platz"],
  "puppe": ["Pup","pe"],
  "putzen": ["put","zen"],
  "rennen": ["ren","nen"],
  "rollen": ["rol","len"],
  "rock": ["Rock"],
  "rücken": ["Rü","cken"],
  "sammeln": ["sam","meln"],
  "schaffen": ["schaf","fen"],
  "schiff": ["Schiff"],
  "schloss": ["Schloss"],
  "schlüssel": ["Schlüs","sel"],
  "schmecken": ["schme","cken"],
  "schmutz": ["Schmutz"],
  "schnell": ["schnell"],
  "schreck": ["Schreck"],
  "schütteln": ["schüt","teln"],
  "schutz": ["Schutz"],
  "schwimmen": ["schwim","men"],
  "schwitzen": ["schwit","zen"],
  "sessel": ["Ses","sel"],
  "setzen": ["set","zen"],
  "sitzen": ["sit","zen"],
  "sommer": ["Som","mer"],
  "sonne": ["Son","ne"],
  "tanne": ["Tan","ne"],
  "tasse": ["Tas","se"],
  "teller": ["Tel","ler"],
  "toll": ["toll"],
  "treffen": ["tref","fen"],
  "trocken": ["tro","cken"],
  "voll": ["voll"],
  "wasser": ["Was","ser"],
  "witzig": ["wit","zig"],
  "zimmer": ["Zim","mer"],
  "zucker": ["Zu","cker"],
  "allein": ["al","lein"],
  "bekommen": ["be","kom","men"],
  "bisschen": ["biss","chen"],
  "donnerstag": ["Don","ners","tag"],
  "entdecken": ["ent","de","cken"],
  "entwickeln": ["ent","wi","ckeln"],
  "erinnern": ["er","in","nern"],
  "erschrecken": ["er","schre","cken"],
  "fußball": ["Fuß","ball"],
  "hallo": ["hal","lo"],
  "herstellen": ["her","stel","len"],
  "hoffentlich": ["hof","fent","lich"],
  "innerhalb": ["in","ner","halb"],
  "interessant": ["in","ter","es","sant"],
  "jetzt": ["jetzt"],
  "kaputt": ["ka","putt"],
  "letzte": ["letz","te"],
  "mittag": ["Mit","tag"],
  "mittwoch": ["Mitt","woch"],
  "passieren": ["pas","sie","ren"],
  "plötzlich": ["plötz","lich"],
  "programm": ["Pro","gramm"],
  "pullover": ["Pull","over"],
  "pommes": ["Pom","mes"],
  "sonntag": ["Sonn","tag"],
  "überall": ["ü","ber","all"],
  "vergessen": ["ver","ges","sen"],
  "verletzen": ["ver","let","zen"],
  "verstecken": ["ver","ste","cken"],
  "vielleicht": ["viel","leicht"],
  "zuletzt": ["zu","letzt"],
  "zurück": ["zu","rück"],
  "zusammen": ["zu","sam","men"],
  "blühen": ["blü","hen"],
  "drehen": ["dre","hen"],
  "früh": ["früh"],
  "gehen": ["ge","hen"],
  "kuh": ["Kuh"],
  "nah": ["nah"],
  "reh": ["Reh"],
  "reihe": ["Rei","he"],
  "ruhe": ["Ru","he"],
  "schuh": ["Schuh"],
  "sehen": ["se","hen"],
  "zeh": ["Zeh"],
  "ziehen": ["zie","hen"],
  "bahn": ["Bahn"],
  "bohren": ["boh","ren"],
  "fahren": ["fah","ren"],
  "fehlen": ["feh","len"],
  "fehler": ["Feh","ler"],
  "fühlen": ["füh","len"],
  "höhle": ["Höh","le"],
  "huhn": ["Huhn"],
  "jahr": ["Jahr"],
  "kühl": ["kühl"],
  "lehrer": ["Leh","rer"],
  "nehmen": ["neh","men"],
  "ohr": ["Ohr"],
  "rühren": ["rüh","ren"],
  "uhr": ["Uhr"],
  "wohl": ["wohl"],
  "wohnen": ["woh","nen"],
  "zahl": ["Zahl"],
  "zahn": ["Zahn"],
  "zehn": ["zehn"],
  "ähnlich": ["ähn","lich"],
  "bezahlen": ["be","zah","len"],
  "erzählen": ["er","zäh","len"],
  "fahrrad": ["Fahr","rad"],
  "frühling": ["Früh","ling"],
  "frühstück": ["Früh","stück"],
  "gefahr": ["Ge","fahr"],
  "ungefähr": ["un","ge","fähr"],
  "verkehr": ["Ver","kehr"],
  "während": ["wäh","rend"],
  "weihnachten": ["Weih","nach","ten"],
  "beere": ["Bee","re"],
  "boot": ["Boot"],
  "haar": ["Haar"],
  "idee": ["Idee"],
  "leer": ["leer"],
  "meer": ["Meer"],
  "paar": ["paar"],
  "schnee": ["Schnee"],
  "see": ["See"],
  "tee": ["Tee"],
  "zoo": ["Zoo"],
  "abend": ["Abend"],
  "berg": ["Berg"],
  "bild": ["Bild"],
  "blind": ["blind"],
  "feld": ["Feld"],
  "fremd": ["fremd"],
  "freund": ["Freund"],
  "gelb": ["gelb"],
  "genug": ["ge","nug"],
  "genügende": ["ge","nü","gen","de"],
  "gesund": ["ge","sund"],
  "grund": ["Grund"],
  "gründe": ["Grün","de"],
  "hemd": ["Hemd"],
  "hund": ["Hund"],
  "kind": ["Kind"],
  "kleid": ["Kleid"],
  "klug": ["klug"],
  "krieg": ["Krieg"],
  "lieb": ["lieb"],
  "lied": ["Lied"],
  "mund": ["Mund"],
  "münder": ["Mün","der"],
  "pferd": ["Pferd"],
  "rund": ["rund"],
  "tag": ["Tag"],
  "tausend": ["tau","send"],
  "tod": ["Tod"],
  "urlaub": ["Ur","laub"],
  "weg": ["Weg"],
  "wild": ["wild"],
  "wind": ["Wind"],
  "zug": ["Zug"],
  "züge": ["Zü","ge"],
  "flugzeug": ["Flug","zeug"],
  "montag": ["Mon","tag"],
  "dienstag": ["Diens","tag"],
  "freitag": ["Frei","tag"],
  "samstag": ["Sams","tag"],
  "deshalb": ["des","halb"],
  "endlich": ["end","lich"],
  "ergebnis": ["Er","geb","nis"],
  "herbst": ["Herbst"],
  "irgend": ["ir","gend"],
  "jemand": ["je","mand"],
  "jugend": ["Ju","gend"],
  "mädchen": ["Mäd","chen"],
  "niemand": ["nie","mand"],
  "ob": ["ob"],
  "obst": ["Obst"],
  "ordnung": ["Ord","nung"],
  "sand": ["Sand"],
  "selbst": ["selbst"],
  "unterwegs": ["un","ter","wegs"],
  "aufräumen": ["auf","räu","men"],
  "aufwachen": ["auf","wa","chen"],
  "gesicht": ["Ge","sicht"],
  "deutlich": ["deut","lich"],
  "eigentlich": ["ei","gent","lich"],
  "nämlich": ["näm","lich"],
  "natürlich": ["na","tür","lich"],
  "schließlich": ["schließ","lich"],
  "fertig": ["fer","tig"],
  "fleißig": ["flei","ßig"],
  "käfig": ["Kä","fig"],
  "könig": ["Kö","nig"],
  "mutig": ["mu","tig"],
  "richtig": ["rich","tig"],
  "riesig": ["rie","sig"],
  "schwierig": ["schwie","rig"],
  "vorsichtig": ["vor","sich","tig"],
  "bevor": ["be","vor"],
  "brav": ["brav"],
  "davon": ["da","von"],
  "november": ["No","vem","ber"],
  "silvester": ["Sil","ves","ter"],
  "vase": ["Va","se"],
  "vater": ["Va","ter"],
  "verbieten": ["ver","bie","ten"],
  "verein": ["Ver","ein"],
  "verlieren": ["ver","lie","ren"],
  "versuch": ["Ver","such"],
  "verwandt": ["ver","wandt"],
  "viele": ["vie","le"],
  "vier": ["vier"],
  "virus": ["Vi","rus"],
  "vogel": ["Vo","gel"],
  "vorne": ["vor","ne"],
  "vorwärts": ["vor","wärts"],
  "vulkan": ["Vul","kan"],
  "dachs": ["Dachs"],
  "fuchs": ["Fuchs"],
  "sechs": ["sechs"],
  "wachs": ["Wachs"],
  "wachsen": ["wach","sen"],
  "wechseln": ["wech","seln"],
  "boxen": ["bo","xen"],
  "hexe": ["He","xe"],
  "lexikon": ["Le","xi","kon"],
  "taxi": ["Ta","xi"],
  "text": ["Text"],
  "baby": ["Ba","by"],
  "handy": ["Han","dy"],
  "pony": ["Po","ny"],
  "teddy": ["Ted","dy"],
  "cent": ["Cent"],
  "clown": ["Clown"],
  "comic": ["Co","mic"],
  "computer": ["Com","pu","ter"],
  "chance": ["Chan","ce"],
  "chef": ["Chef"],
  "chor": ["Chor"],
  "ärgern": ["är","gern"],
  "bär": ["Bär"],
  "erklären": ["er","klä","ren"],
  "hängen": ["hän","gen"],
  "käfer": ["Kä","fer"],
  "käse": ["Kä","se"],
  "lärm": ["Lärm"],
  "märz": ["März"],
  "nächste": ["nächs","te"],
  "träne": ["Trä","ne"],
  "auto": ["Au","to"],
  "bus": ["Bus"],
  "e-mail": ["E-Mail"],
  "euro": ["Eu","ro"],
  "europa": ["Eu","ro","pa"],
  "fair": ["fair"],
  "ferien": ["Fe","ri","en"],
  "internet": ["In","ter","net"],
  "kalender": ["Ka","len","der"],
  "lineal": ["Li","ne","al"],
  "linie": ["Li","ni","e"],
  "mai": ["Mai"],
  "maschine": ["Ma","schi","ne"],
  "medien": ["Me","di","en"],
  "minute": ["Mi","nu","te"],
  "monat": ["Mo","nat"],
  "musik": ["Mu","sik"],
  "paket": ["Pa","ket"],
  "pizza": ["Piz","za"],
  "radio": ["Ra","di","o"],
  "sekunde": ["Se","kun","de"],
  "telefon": ["Te","le","fon"],
  "temperatur": ["Tem","pe","ra","tur"],
  "theater": ["The","a","ter"],
  "thema": ["The","ma"],
  "trainieren": ["trai","nie","ren"],
  "januar": ["Ja","nu","ar"],
  "februar": ["Fe","bru","ar"],
  "april": ["April"],
  "juni": ["Ju","ni"],
  "juli": ["Ju","li"],
  "august": ["Au","gust"],
  "september": ["Sep","tem","ber"],
  "oktober": ["Ok","to","ber"],
  "dezember": ["De","zem","ber"],
  "igel": ["Igel"],
  "liter": ["Li","ter"],
  "tiger": ["Ti","ger"],
  "bereits": ["be","reits"],
  "draht": ["Draht"],
  "geburtstag": ["Ge","burts","tag"],
  "links": ["links"],
  "rechts": ["rechts"],
  "außen": ["au","ßen"],
  "beißen": ["bei","ßen"],
  "bloß": ["bloß"],
  "draußen": ["drau","ßen"],
  "fließen": ["flie","ßen"],
  "fuß": ["Fuß"],
  "gießen": ["gie","ßen"],
  "groß": ["groß"],
  "grüßen": ["grü","ßen"],
  "heiß": ["heiß"],
  "ließen": ["lie","ßen"],
  "reißen": ["rei","ßen"],
  "schließen": ["schlie","ßen"],
  "soße": ["So","ße"],
  "süß": ["süß"],
  "weiß": ["weiß"],
  "entfernung": ["Ent","fer","nung"],
  "heizung": ["Hei","zung"],
  "zeitung": ["Zei","tung"],
  "zeugnis": ["Zeug","nis"],
};
